import React from "react";
import { Modal, Button } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import localization from "../../services/localization";
import { FaExclamationTriangle } from "react-icons/fa";

const DeleteModal = ({
  show,
  itemName,
  onClose,
  onConfirm,
  loading,
  setLoading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="themed-modal addEditModal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {localization.confirm_delete || "Confirm Delete"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column align-items-center justify-content-center text-center">
        <FaExclamationTriangle className="text-warning fs-1 mb-3" />
        <h5 className="main-title mb-3">
          {localization.delete_confirmation_text ||
            "Are you sure you want to delete this item?"}
        </h5>
        <p className="description-text">
          {localization.delete_warning ? (
            <>
              {localization.delete_warning.split("{itemName}")[0]}
              <strong className="main-title">{itemName}</strong>
              {localization.delete_warning.split("{itemName}")[1]}
            </>
          ) : (
            <>
              This will permanently delete <strong>{itemName}</strong> and
              cannot be undone.
            </>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {localization.cancel || "Cancel"}
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={loading} // prevent multiple clicks
          className="d-flex align-items-center justify-content-center gap-2"
        >
          {loading && <ClipLoader size={16} color="var(--primary-icon)" />}
          {loading ? "Deleting..." : localization.delete || "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
